import React from 'react';
// ⚠️ IMPORTANT: Must import FileText for the PDF/Image view icon
import { BookOpen, Bookmark, Type, Menu, FileText } from 'lucide-react'; 

type TabName = 'contents' | 'bookmark' | 'format'; // 'text' is handled by the toggle logic
type ViewMode = 'image' | 'text';

interface BottomtabbarProps {
    onTabClick: (tab: TabName) => void;
    // NEW PROPS: Received from ImageViewer
    viewMode: ViewMode;
    toggleViewMode: () => void;
}

const Bottomtabbar: React.FC<BottomtabbarProps> = ({ 
    onTabClick, 
    viewMode, 
    toggleViewMode 
}) => {
    
    // Tabs that perform a different action (not the view toggle)
   {/* const primaryTabs = [
        { id: 'contents' as TabName, label: 'Contents', icon: BookOpen }, 
        { id: 'bookmark' as TabName, label: 'Bookmark', icon: Bookmark },
        { id: 'format' as TabName, label: 'Format', icon: Menu }, 
    ];*/}

    // The special 'text'/'view-mode' tab configuration
    const viewModeTab = { 
        id: 'text', // Used for key/class, but its action is different
        // Label changes: 'TEXT' (to switch to text) or 'PDF' (to switch back to image/PDF)
        label: viewMode === 'image' ? 'PDF' : 'TEXT', 
        // Icon changes: Type (to suggest text) or FileText (to suggest file/image)
        icon: viewMode === 'image' ? FileText : Type,
    };

    return (
        <div className="bottom-tab-bar">
            {/* 1. Render primary navigation tabs */}
            {/* {primaryTabs.map((tab) => (
                <button 
                    key={tab.id}
                    className="tab-item"
                    onClick={() => onTabClick(tab.id)}
                >
                    <tab.icon size={20} className="tab-icon" />
                    <span className="tab-label">{tab.label}</span>
                </button>
            ))}*/}

            {/* 2. Render the View Mode Toggle Tab */}
            <button 
                key={viewModeTab.id}
                className={`tab-item view-mode-toggle-tab ${viewMode === 'text' ? 'active' : ''}`}
                
                //onClick={toggleViewMode} 
                title={viewMode === 'image' ? 'Switch to Text View' : 'Switch to Image View'}
            >
                {/* Dynamically render the icon and label based on state */}
                <viewModeTab.icon size={20} className="tab-icon" />
                <span className="tab-label">{viewModeTab.label}</span>
            </button>
        </div>
    );
};

export default Bottomtabbar;